var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMneuBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5169 18.5H11.5169V3.5C11.5169 2.70435 11.8329 1.94129 12.3955 1.37868C12.9582 0.816071 13.7212 0.5 14.5169 0.5H19.5169C19.7821 0.5 20.0364 0.605357 20.224 0.792893C20.4115 0.98043 20.5169 1.23478 20.5169 1.5V17.5C20.5169 17.7652 20.4115 18.0196 20.224 18.2071C20.0364 18.3946 19.7821 18.5 19.5169 18.5ZM9.51687 18.5H1.51687C1.25165 18.5 0.997298 18.3946 0.809762 18.2071C0.622225 18.0196 0.516869 17.7652 0.516869 17.5V1.5C0.516869 1.23478 0.622225 0.98043 0.809762 0.792893C0.997298 0.605357 1.25165 0.5 1.51687 0.5H6.51687C7.31252 0.5 8.07558 0.816071 8.63819 1.37868C9.2008 1.94129 9.51687 2.70435 9.51687 3.5V18.5ZM9.51687 18.5H11.5169V20.5H9.51687V18.5Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMneuBar);
export default __webpack_public_path__ + "static/media/MneuBar.5ccb9d389944bf8d00e8512674aa9d50.svg";
export { ForwardRef as ReactComponent };